export default __webpack_public_path__ + "static/nadia-fadil-8acde172991c8eceed5277f3dbd508cb.png";